// The SVG for each two-letter flag, loaded only when that country is shown. Each entry is its
// own chunk, so the first page load carries no flags. The list mirrors country-flag-icons 1.6.20
// (pinned in package.json). It is written as literal imports, because bundlers and bun resolve them.
export const FLAG_LOADERS: Record<string, (() => Promise<{ default: string }>) | undefined> = {
  AC: () => import("country-flag-icons/string/3x2/AC"),
  AD: () => import("country-flag-icons/string/3x2/AD"),
  AE: () => import("country-flag-icons/string/3x2/AE"),
  AF: () => import("country-flag-icons/string/3x2/AF"),
  AG: () => import("country-flag-icons/string/3x2/AG"),
  AI: () => import("country-flag-icons/string/3x2/AI"),
  AL: () => import("country-flag-icons/string/3x2/AL"),
  AM: () => import("country-flag-icons/string/3x2/AM"),
  AO: () => import("country-flag-icons/string/3x2/AO"),
  AQ: () => import("country-flag-icons/string/3x2/AQ"),
  AR: () => import("country-flag-icons/string/3x2/AR"),
  AS: () => import("country-flag-icons/string/3x2/AS"),
  AT: () => import("country-flag-icons/string/3x2/AT"),
  AU: () => import("country-flag-icons/string/3x2/AU"),
  AW: () => import("country-flag-icons/string/3x2/AW"),
  AX: () => import("country-flag-icons/string/3x2/AX"),
  AZ: () => import("country-flag-icons/string/3x2/AZ"),
  BA: () => import("country-flag-icons/string/3x2/BA"),
  BB: () => import("country-flag-icons/string/3x2/BB"),
  BD: () => import("country-flag-icons/string/3x2/BD"),
  BE: () => import("country-flag-icons/string/3x2/BE"),
  BF: () => import("country-flag-icons/string/3x2/BF"),
  BG: () => import("country-flag-icons/string/3x2/BG"),
  BH: () => import("country-flag-icons/string/3x2/BH"),
  BI: () => import("country-flag-icons/string/3x2/BI"),
  BJ: () => import("country-flag-icons/string/3x2/BJ"),
  BL: () => import("country-flag-icons/string/3x2/BL"),
  BM: () => import("country-flag-icons/string/3x2/BM"),
  BN: () => import("country-flag-icons/string/3x2/BN"),
  BO: () => import("country-flag-icons/string/3x2/BO"),
  BQ: () => import("country-flag-icons/string/3x2/BQ"),
  BR: () => import("country-flag-icons/string/3x2/BR"),
  BS: () => import("country-flag-icons/string/3x2/BS"),
  BT: () => import("country-flag-icons/string/3x2/BT"),
  BV: () => import("country-flag-icons/string/3x2/BV"),
  BW: () => import("country-flag-icons/string/3x2/BW"),
  BY: () => import("country-flag-icons/string/3x2/BY"),
  BZ: () => import("country-flag-icons/string/3x2/BZ"),
  CA: () => import("country-flag-icons/string/3x2/CA"),
  CC: () => import("country-flag-icons/string/3x2/CC"),
  CD: () => import("country-flag-icons/string/3x2/CD"),
  CF: () => import("country-flag-icons/string/3x2/CF"),
  CG: () => import("country-flag-icons/string/3x2/CG"),
  CH: () => import("country-flag-icons/string/3x2/CH"),
  CI: () => import("country-flag-icons/string/3x2/CI"),
  CK: () => import("country-flag-icons/string/3x2/CK"),
  CL: () => import("country-flag-icons/string/3x2/CL"),
  CM: () => import("country-flag-icons/string/3x2/CM"),
  CN: () => import("country-flag-icons/string/3x2/CN"),
  CO: () => import("country-flag-icons/string/3x2/CO"),
  CR: () => import("country-flag-icons/string/3x2/CR"),
  CU: () => import("country-flag-icons/string/3x2/CU"),
  CV: () => import("country-flag-icons/string/3x2/CV"),
  CW: () => import("country-flag-icons/string/3x2/CW"),
  CX: () => import("country-flag-icons/string/3x2/CX"),
  CY: () => import("country-flag-icons/string/3x2/CY"),
  CZ: () => import("country-flag-icons/string/3x2/CZ"),
  DE: () => import("country-flag-icons/string/3x2/DE"),
  DJ: () => import("country-flag-icons/string/3x2/DJ"),
  DK: () => import("country-flag-icons/string/3x2/DK"),
  DM: () => import("country-flag-icons/string/3x2/DM"),
  DO: () => import("country-flag-icons/string/3x2/DO"),
  DZ: () => import("country-flag-icons/string/3x2/DZ"),
  EC: () => import("country-flag-icons/string/3x2/EC"),
  EE: () => import("country-flag-icons/string/3x2/EE"),
  EG: () => import("country-flag-icons/string/3x2/EG"),
  EH: () => import("country-flag-icons/string/3x2/EH"),
  ER: () => import("country-flag-icons/string/3x2/ER"),
  ES: () => import("country-flag-icons/string/3x2/ES"),
  ET: () => import("country-flag-icons/string/3x2/ET"),
  EU: () => import("country-flag-icons/string/3x2/EU"),
  FI: () => import("country-flag-icons/string/3x2/FI"),
  FJ: () => import("country-flag-icons/string/3x2/FJ"),
  FK: () => import("country-flag-icons/string/3x2/FK"),
  FM: () => import("country-flag-icons/string/3x2/FM"),
  FO: () => import("country-flag-icons/string/3x2/FO"),
  FR: () => import("country-flag-icons/string/3x2/FR"),
  GA: () => import("country-flag-icons/string/3x2/GA"),
  GB: () => import("country-flag-icons/string/3x2/GB"),
  GD: () => import("country-flag-icons/string/3x2/GD"),
  GE: () => import("country-flag-icons/string/3x2/GE"),
  GF: () => import("country-flag-icons/string/3x2/GF"),
  GG: () => import("country-flag-icons/string/3x2/GG"),
  GH: () => import("country-flag-icons/string/3x2/GH"),
  GI: () => import("country-flag-icons/string/3x2/GI"),
  GL: () => import("country-flag-icons/string/3x2/GL"),
  GM: () => import("country-flag-icons/string/3x2/GM"),
  GN: () => import("country-flag-icons/string/3x2/GN"),
  GP: () => import("country-flag-icons/string/3x2/GP"),
  GQ: () => import("country-flag-icons/string/3x2/GQ"),
  GR: () => import("country-flag-icons/string/3x2/GR"),
  GS: () => import("country-flag-icons/string/3x2/GS"),
  GT: () => import("country-flag-icons/string/3x2/GT"),
  GU: () => import("country-flag-icons/string/3x2/GU"),
  GW: () => import("country-flag-icons/string/3x2/GW"),
  GY: () => import("country-flag-icons/string/3x2/GY"),
  HK: () => import("country-flag-icons/string/3x2/HK"),
  HM: () => import("country-flag-icons/string/3x2/HM"),
  HN: () => import("country-flag-icons/string/3x2/HN"),
  HR: () => import("country-flag-icons/string/3x2/HR"),
  HT: () => import("country-flag-icons/string/3x2/HT"),
  HU: () => import("country-flag-icons/string/3x2/HU"),
  IC: () => import("country-flag-icons/string/3x2/IC"),
  ID: () => import("country-flag-icons/string/3x2/ID"),
  IE: () => import("country-flag-icons/string/3x2/IE"),
  IL: () => import("country-flag-icons/string/3x2/IL"),
  IM: () => import("country-flag-icons/string/3x2/IM"),
  IN: () => import("country-flag-icons/string/3x2/IN"),
  IO: () => import("country-flag-icons/string/3x2/IO"),
  IQ: () => import("country-flag-icons/string/3x2/IQ"),
  IR: () => import("country-flag-icons/string/3x2/IR"),
  IS: () => import("country-flag-icons/string/3x2/IS"),
  IT: () => import("country-flag-icons/string/3x2/IT"),
  JE: () => import("country-flag-icons/string/3x2/JE"),
  JM: () => import("country-flag-icons/string/3x2/JM"),
  JO: () => import("country-flag-icons/string/3x2/JO"),
  JP: () => import("country-flag-icons/string/3x2/JP"),
  KE: () => import("country-flag-icons/string/3x2/KE"),
  KG: () => import("country-flag-icons/string/3x2/KG"),
  KH: () => import("country-flag-icons/string/3x2/KH"),
  KI: () => import("country-flag-icons/string/3x2/KI"),
  KM: () => import("country-flag-icons/string/3x2/KM"),
  KN: () => import("country-flag-icons/string/3x2/KN"),
  KP: () => import("country-flag-icons/string/3x2/KP"),
  KR: () => import("country-flag-icons/string/3x2/KR"),
  KW: () => import("country-flag-icons/string/3x2/KW"),
  KY: () => import("country-flag-icons/string/3x2/KY"),
  KZ: () => import("country-flag-icons/string/3x2/KZ"),
  LA: () => import("country-flag-icons/string/3x2/LA"),
  LB: () => import("country-flag-icons/string/3x2/LB"),
  LC: () => import("country-flag-icons/string/3x2/LC"),
  LI: () => import("country-flag-icons/string/3x2/LI"),
  LK: () => import("country-flag-icons/string/3x2/LK"),
  LR: () => import("country-flag-icons/string/3x2/LR"),
  LS: () => import("country-flag-icons/string/3x2/LS"),
  LT: () => import("country-flag-icons/string/3x2/LT"),
  LU: () => import("country-flag-icons/string/3x2/LU"),
  LV: () => import("country-flag-icons/string/3x2/LV"),
  LY: () => import("country-flag-icons/string/3x2/LY"),
  MA: () => import("country-flag-icons/string/3x2/MA"),
  MC: () => import("country-flag-icons/string/3x2/MC"),
  MD: () => import("country-flag-icons/string/3x2/MD"),
  ME: () => import("country-flag-icons/string/3x2/ME"),
  MF: () => import("country-flag-icons/string/3x2/MF"),
  MG: () => import("country-flag-icons/string/3x2/MG"),
  MH: () => import("country-flag-icons/string/3x2/MH"),
  MK: () => import("country-flag-icons/string/3x2/MK"),
  ML: () => import("country-flag-icons/string/3x2/ML"),
  MM: () => import("country-flag-icons/string/3x2/MM"),
  MN: () => import("country-flag-icons/string/3x2/MN"),
  MO: () => import("country-flag-icons/string/3x2/MO"),
  MP: () => import("country-flag-icons/string/3x2/MP"),
  MQ: () => import("country-flag-icons/string/3x2/MQ"),
  MR: () => import("country-flag-icons/string/3x2/MR"),
  MS: () => import("country-flag-icons/string/3x2/MS"),
  MT: () => import("country-flag-icons/string/3x2/MT"),
  MU: () => import("country-flag-icons/string/3x2/MU"),
  MV: () => import("country-flag-icons/string/3x2/MV"),
  MW: () => import("country-flag-icons/string/3x2/MW"),
  MX: () => import("country-flag-icons/string/3x2/MX"),
  MY: () => import("country-flag-icons/string/3x2/MY"),
  MZ: () => import("country-flag-icons/string/3x2/MZ"),
  NA: () => import("country-flag-icons/string/3x2/NA"),
  NC: () => import("country-flag-icons/string/3x2/NC"),
  NE: () => import("country-flag-icons/string/3x2/NE"),
  NF: () => import("country-flag-icons/string/3x2/NF"),
  NG: () => import("country-flag-icons/string/3x2/NG"),
  NI: () => import("country-flag-icons/string/3x2/NI"),
  NL: () => import("country-flag-icons/string/3x2/NL"),
  NO: () => import("country-flag-icons/string/3x2/NO"),
  NP: () => import("country-flag-icons/string/3x2/NP"),
  NR: () => import("country-flag-icons/string/3x2/NR"),
  NU: () => import("country-flag-icons/string/3x2/NU"),
  NZ: () => import("country-flag-icons/string/3x2/NZ"),
  OM: () => import("country-flag-icons/string/3x2/OM"),
  PA: () => import("country-flag-icons/string/3x2/PA"),
  PE: () => import("country-flag-icons/string/3x2/PE"),
  PF: () => import("country-flag-icons/string/3x2/PF"),
  PG: () => import("country-flag-icons/string/3x2/PG"),
  PH: () => import("country-flag-icons/string/3x2/PH"),
  PK: () => import("country-flag-icons/string/3x2/PK"),
  PL: () => import("country-flag-icons/string/3x2/PL"),
  PM: () => import("country-flag-icons/string/3x2/PM"),
  PN: () => import("country-flag-icons/string/3x2/PN"),
  PR: () => import("country-flag-icons/string/3x2/PR"),
  PS: () => import("country-flag-icons/string/3x2/PS"),
  PT: () => import("country-flag-icons/string/3x2/PT"),
  PW: () => import("country-flag-icons/string/3x2/PW"),
  PY: () => import("country-flag-icons/string/3x2/PY"),
  QA: () => import("country-flag-icons/string/3x2/QA"),
  RE: () => import("country-flag-icons/string/3x2/RE"),
  RO: () => import("country-flag-icons/string/3x2/RO"),
  RS: () => import("country-flag-icons/string/3x2/RS"),
  RU: () => import("country-flag-icons/string/3x2/RU"),
  RW: () => import("country-flag-icons/string/3x2/RW"),
  SA: () => import("country-flag-icons/string/3x2/SA"),
  SB: () => import("country-flag-icons/string/3x2/SB"),
  SC: () => import("country-flag-icons/string/3x2/SC"),
  SD: () => import("country-flag-icons/string/3x2/SD"),
  SE: () => import("country-flag-icons/string/3x2/SE"),
  SG: () => import("country-flag-icons/string/3x2/SG"),
  SH: () => import("country-flag-icons/string/3x2/SH"),
  SI: () => import("country-flag-icons/string/3x2/SI"),
  SJ: () => import("country-flag-icons/string/3x2/SJ"),
  SK: () => import("country-flag-icons/string/3x2/SK"),
  SL: () => import("country-flag-icons/string/3x2/SL"),
  SM: () => import("country-flag-icons/string/3x2/SM"),
  SN: () => import("country-flag-icons/string/3x2/SN"),
  SO: () => import("country-flag-icons/string/3x2/SO"),
  SR: () => import("country-flag-icons/string/3x2/SR"),
  SS: () => import("country-flag-icons/string/3x2/SS"),
  ST: () => import("country-flag-icons/string/3x2/ST"),
  SV: () => import("country-flag-icons/string/3x2/SV"),
  SX: () => import("country-flag-icons/string/3x2/SX"),
  SY: () => import("country-flag-icons/string/3x2/SY"),
  SZ: () => import("country-flag-icons/string/3x2/SZ"),
  TA: () => import("country-flag-icons/string/3x2/TA"),
  TC: () => import("country-flag-icons/string/3x2/TC"),
  TD: () => import("country-flag-icons/string/3x2/TD"),
  TF: () => import("country-flag-icons/string/3x2/TF"),
  TG: () => import("country-flag-icons/string/3x2/TG"),
  TH: () => import("country-flag-icons/string/3x2/TH"),
  TJ: () => import("country-flag-icons/string/3x2/TJ"),
  TK: () => import("country-flag-icons/string/3x2/TK"),
  TL: () => import("country-flag-icons/string/3x2/TL"),
  TM: () => import("country-flag-icons/string/3x2/TM"),
  TN: () => import("country-flag-icons/string/3x2/TN"),
  TO: () => import("country-flag-icons/string/3x2/TO"),
  TR: () => import("country-flag-icons/string/3x2/TR"),
  TT: () => import("country-flag-icons/string/3x2/TT"),
  TV: () => import("country-flag-icons/string/3x2/TV"),
  TW: () => import("country-flag-icons/string/3x2/TW"),
  TZ: () => import("country-flag-icons/string/3x2/TZ"),
  UA: () => import("country-flag-icons/string/3x2/UA"),
  UG: () => import("country-flag-icons/string/3x2/UG"),
  UM: () => import("country-flag-icons/string/3x2/UM"),
  US: () => import("country-flag-icons/string/3x2/US"),
  UY: () => import("country-flag-icons/string/3x2/UY"),
  UZ: () => import("country-flag-icons/string/3x2/UZ"),
  VA: () => import("country-flag-icons/string/3x2/VA"),
  VC: () => import("country-flag-icons/string/3x2/VC"),
  VE: () => import("country-flag-icons/string/3x2/VE"),
  VG: () => import("country-flag-icons/string/3x2/VG"),
  VI: () => import("country-flag-icons/string/3x2/VI"),
  VN: () => import("country-flag-icons/string/3x2/VN"),
  VU: () => import("country-flag-icons/string/3x2/VU"),
  WF: () => import("country-flag-icons/string/3x2/WF"),
  WS: () => import("country-flag-icons/string/3x2/WS"),
  XA: () => import("country-flag-icons/string/3x2/XA"),
  XC: () => import("country-flag-icons/string/3x2/XC"),
  XK: () => import("country-flag-icons/string/3x2/XK"),
  XO: () => import("country-flag-icons/string/3x2/XO"),
  YE: () => import("country-flag-icons/string/3x2/YE"),
  YT: () => import("country-flag-icons/string/3x2/YT"),
  ZA: () => import("country-flag-icons/string/3x2/ZA"),
  ZM: () => import("country-flag-icons/string/3x2/ZM"),
  ZW: () => import("country-flag-icons/string/3x2/ZW"),
};
